export default {
  text: 'Otwórz profil {{paymentGateway}}',
  text_generic: 'Otwórz profil onboardingowy',
  toasts: {
    failed_to_create: 'Nie udało się otworzyć profilu {{paymentGateway}}',
    link_copied: 'Link skopiowany do schowka',
    copy_failed: 'Nie udało się skopiować linku',
  },
};
